import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

/**
 * Link for quote-intent navigation. Google Ads lead conversions are reported
 * only after a validated contact form submission succeeds.
 */
export const GoogleAdsRequestQuoteLink = forwardRef(function GoogleAdsRequestQuoteLink(
  { to, href, onClick, target, ...props },
  ref,
) {
  const handleClick = (event) => {
    onClick?.(event);
  };

  if (to) {
    return <Link ref={ref} to={to} target={target} onClick={handleClick} {...props} />;
  }

  return <a ref={ref} href={href} target={target} onClick={handleClick} {...props} />;
});
